import { tableBookGalleryApi } from '../../api/menu/tableBookGalleryApi';
import { TABLE_BOOK_GALLERY_REQUEST, TABLE_BOOK_GALLERY_SUCCESS, TABLE_BOOK_GALLERY_FAILURE } from '../types';

export const getTableGalleryRequest = () => ({
    type: TABLE_BOOK_GALLERY_REQUEST,
});
  
export const getTableGallerySuccess = (pageData) => ({
    type: TABLE_BOOK_GALLERY_SUCCESS,
    payload: pageData,
});
  
export const getTableGalleryFailure = (error) => ({
    type: TABLE_BOOK_GALLERY_FAILURE,
    payload: error,
});
  
export const getTableGalleryDetail = (formData) => {
    return dispatch => {
      dispatch(getTableGalleryRequest());
      tableBookGalleryApi(formData)
        .then((response) => {
            if(response.data.status === true) {
                // alert(JSON.stringify(response.data))
                dispatch(getTableGallerySuccess(response.data)); 
            } else {
                dispatch(getTableGalleryFailure(response.data.message));
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(getTableGalleryFailure(error.data.message));
        });
    };
};
  